import styled from 'styled-components';
import { Typography, Box } from '@mui/material';
import { Flex, FlexColumn } from '../../../components/Flex';

const Wrapper = styled(FlexColumn)`
  gap: 12px;
`;

const Item = styled(Flex)`
  gap: 8px;
  align-items: center;
`;

const Name = styled(Typography)`
  color: ${({ theme }) => theme.palette.common.gray2};
  font-size: 13px;
`;

const Dot = styled(Box)<{ color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 100%;
  background: ${({ color }) => color};
`;

type Props = {
  categories: {
    name: string;
    color: string;
  }[];
};

const Legend = ({ categories }: Props) => (
  <Wrapper>
    {categories.map((category) => (
      <Item key={category.name}>
        <Dot color={category.color} />
        <Name>{category.name}</Name>
      </Item>
    ))}
  </Wrapper>
);

export default Legend;
